import React from "react";
import { connect } from "react-redux";
import { BannerDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { ROUTE_PATH } from "utils/constants/routePath";
import { AlertControl } from "components/Modals/Alert";
import { Displays, Forms } from "components";

class BannerDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    if (this.props.router.params.id !== "create") {
      this.fetchData();
    } else {
      this.setState({
        isLoading: false,
        isBgLoading: false,
      });
    }
  }

  fetchData = async () => {
    let res = await portalService.GET_BANNER_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      this.setState({
        initialValues: res.data,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  // FLOW DELETE
  // =============================
  // =============================
  handleDelete = () => {
    AlertControl.show({
      title: "ยืนยันการลบ",
      description: "คุณต้องการจะลบ Banner นี้ใช่หรือไม่",
      btnLabel1: "ยกเลิก",
      btnLabel2: "ยืนยัน",
      onEvent2: this.deleteAction,
    });
  };
  deleteAction = async () => {
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.DELETE_BANNER_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      toast.success("ลบสำเร็จ");
      this.handleNextStep();
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error("ลบไม่สำเร็จ");
    }
  };

  // FLOW SUBMIT
  // =============================
  // =============================
  handleSubmit = async (values) => {
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
    };
    let res =
      this.props.router.params.id === "create"
        ? await portalService.POST_BANNER_DETAIL(params)
        : await portalService.PUT_BANNER_UPDATE(
            this.props.router.params.id,
            params
          );
    if (res && res.status === 200) {
      let filesTemp = [];
      if (values.img_file) {
        filesTemp = [...values.img_file.filter((e) => e.isNewUpload)];
      }
      if (filesTemp.length === 0) {
        toast.success("อัพเดตสำเร็จ");
        this.handleNextStep();
      } else {
        this.handleUploadContentMedia(res.data._id, filesTemp);
      }
    } else {
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };
  handleUploadContentMedia = (bannerID, files) => {
    Promise.all(
      files.map((e) => {
        return new Promise(async (resolve) => {
          if (e.isNewUpload) {
            const bodyFormData = new FormData();
            bodyFormData.set("banner_id", bannerID);
            bodyFormData.set("type", e.fieldName);
            bodyFormData.append("image", e);
            let res = await portalService.POST_BANNER_UPLOAD(bodyFormData);
            if (res && res.status === 200) {
              resolve();
            }
          }
        });
      })
    ).then(() => {
      this.setState({
        isBgLoading: false,
      });
      toast.success("อัพเดจสำเร็จ");
      this.handleNextStep();
    });
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  handleNextStep = () => {
    this.props.router.navigate(ROUTE_PATH.FRONTEND_SETTING_BANNER);
  };

  render() {
    const { authenRedux } = this.props;
    const { isLoading, initialValues, isBgLoading } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "frontend_setting");
    return (
      <BannerDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <Forms.BannerForm
            initialValues={initialValues}
            permission={permission}
            onCancel={this.handleCancel}
            onDelete={this.handleDelete}
            onSubmit={this.handleSubmit}
          />
        )}
      </BannerDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BannerDetailContainer));
